export const LOADER_FEATURE_KEY = 'loading';
